import React from 'react'
import styled from '@emotion/styled'
import Typography from '@material-ui/core/Typography';
import { windowSize } from 'src/services/hooks/common'
import colorPalette from '~/theme/colorPalette.js';
import { findCategoryLabel } from '/src/services/hooks/item'

// 常時、上下borderデザインにしたい場合は、spMode = true を渡す.
// textがある場合は、textが表示される
const CategoryLabel = ({categoryCode=null, spMode=false, text=null}) => {
  const categoryLabel = categoryCode && findCategoryLabel(categoryCode);
  const code  = text || categoryLabel?.code;
  const label = text || categoryLabel?.label;

  return (
    <>
      { (!code && !label) ? (
        undefined
      ):(
        (windowSize() <= 425 || spMode ) ?
          <SpCategory code={code}>{label}</SpCategory>
        :
          <PcCategory code={code}>{label}</PcCategory>
      )}
    </>
  )
}

export default CategoryLabel

const SpCategory = styled(Typography)({
  borderStyle: 'solid',
  borderWidth: '1px 0 1px 0',
  margin: '1rem 0',
  padding: '0.5rem 0',
  textAlign: 'center',
}, props => ({
  color:  ['healthy','healthy_large'].includes(props.code) ? colorPalette.itemCategories.healthy :
          ['care','extra'].includes(props.code) ? colorPalette.itemCategories.care :
          ['protein'].includes(props.code) ? colorPalette.itemCategories.protein :
          ['セット'].includes(props.code) ? colorPalette.green : colorPalette.gray,
  borderColor:  ['healthy','healthy_large'].includes(props.code) ? colorPalette.itemCategories.healthy :
          ['care','extra'].includes(props.code) ? colorPalette.itemCategories.care :
          ['protein'].includes(props.code) ? colorPalette.itemCategories.protein :
          ['セット'].includes(props.code) ? colorPalette.green : colorPalette.gray,
}))


const PcCategory = styled(Typography)({
  color: '#fff',
  fontSize: '1.1rem',
  fontWeight: '600',
  margin: '1rem 0',
  padding: '0.3rem 0.7rem',
  textAlign: 'center',
}, props => ({
  backgroundColor:  ['healthy','healthy_large'].includes(props.code) ? colorPalette.itemCategories.healthy :
          ['care','extra'].includes(props.code) ? colorPalette.itemCategories.care :
          ['protein'].includes(props.code) ? colorPalette.itemCategories.protein : colorPalette.gray,
}))
